import { useCallback, useEffect, useState } from 'react';
import makeRequest from '@llt-frontend/make-request';
import { useClient } from 'jsonapi-react';
import { utcToZonedTime } from 'date-fns-tz';
import 'allsettled-polyfill';

//TODO: This needs tests...
export const useGetQuotes = () => {
  const params = new URLSearchParams(window.location.search);
  const leadId = params.get('lead_id');
  const clientId = params.get('client_id');

  const client = useClient();
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [data, setData] = useState({ classes: [], packages: [], subscriptions: [] });

  const fetchQuotesAndItems = useCallback(
    async ({ clientId, leadId }) => {
      if (!clientId && !leadId) {
        return;
      }

      setLoading(true);
      setError(false);

      const entity_id = clientId || leadId;
      const entity_type = clientId ? 'client' : 'lead';
      const url = `${process.env.REACT_APP_API_HOST}/v1/${entity_type}s/${entity_id}/pricing_quotes?max_expired_days=7&user_action=autoQuote`;

      try {
        const results = { packages: [], classes: [], subscriptions: [] };

        // get quotes
        const quotesResult = await makeRequest(url);
        const validQuotes = (quotesResult || []).filter(
          (quote) => utcToZonedTime(quote.ends_at, 'America/Chicago') >= new Date(Date.now())
        );
        // get item info from quote items
        // TODO: migrate to v2 items LIST endpoint
        const queries = [];
        for (const quote of validQuotes) {
          const { item_id, name, list_price_cents, duration_seconds, session_length_seconds } =
            quote.items[0];
          if (item_id === '00000000-0000-1000-8080-808080808081') {
            // custom package
            // skip fetch and refer to the data from the quote for rendering
            queries.push(
              Promise.resolve({
                data: {
                  name,
                  meta: { list_price: { amount: list_price_cents } },
                  packages: { duration_seconds, session_length_seconds },
                },
              })
            );
          } else {
            queries.push(
              client.fetch(['v2/items', item_id, { include: ['packages'], entity_id, entity_type }])
            );
          }
        }

        // wait on item results https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/allSettled
        const itemResults = await Promise.allSettled(queries);

        // check item results + pair with quote data
        validQuotes.forEach((quote, idx) => {
          const item = itemResults[idx];
          if (item.status === 'fulfilled' && item.value.data) {
            const result = { quote, item: item.value.data };
            if (Object.keys(result.item.packages).length) {
              results.packages.push(result);
            } else if (item?.value?.data?.commodity_type === 'subscription') {
              results.subscriptions.push(result);
            } else {
              results.classes.push(result);
            }
          }
        });

        setData(results);
      } catch (e) {
        console.error(e);
        setError(true);
      }
      setLoading(false);
    },
    [client]
  );

  useEffect(() => {
    fetchQuotesAndItems({ clientId, leadId });
  }, [fetchQuotesAndItems, clientId, leadId]);

  return {
    isLoading,
    isError,
    data,
  };
};
